import * as React from "react";
import { useMemo } from "react";

import clsx from "clsx";

import { cn } from "~/lib/utils";

const floatingInputClassname =
    "block rounded-t-lg px-2.5 pb-2.5 pt-5 w-full text-sm text-rose-800 bg-white dark:bg-gray-700 border-0 border-b-2 border-rose-800/10 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-rose-600 focus:outline-none focus:ring-0 focus:border-rose-600 peer";

const placeholderToId = (placeholder?: string): string => {
    if (!placeholder) return "";
    return placeholder
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, "") // Remove special characters
        .replace(/\s+/g, "-"); // Replace spaces with dashes
};

const Input = React.forwardRef<
    HTMLInputElement,
    React.ComponentProps<"input"> & { wrapperClassName?: string }
>(({ className, type, wrapperClassName, ...props }, ref) => {
    const id = useMemo(
        () => placeholderToId(props.placeholder),
        [props.placeholder],
    );

    return (
        <div className={clsx("relative", wrapperClassName)}>
            <input
                type={type}
                ref={ref}
                {...props}
                id={id}
                className={cn(floatingInputClassname, className)}
                // empty placeholder to make room for the label.
                placeholder=""
            />
            <label
                htmlFor={id}
                className="absolute start-2.5 top-4 z-10 origin-[0] -translate-y-4 scale-75 text-sm text-rose-900 duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:text-rose-700 dark:text-gray-400 peer-focus:dark:text-rose-600 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
            >
                {props.placeholder}
            </label>
        </div>
    );
});
Input.displayName = "Input";

export { Input };
